export const state = {
  credentials: {
    login: undefined,
    password: undefined,
  },
};

export default state;
